import {AlertIcon} from '@primer/octicons-react'
import {ActionList} from '@primer/react'

// eslint-disable-next-line @github-ui/github-monorepo/restrict-relay-imports
import type {CodeVulnerability} from '@github-ui/copilot-chat/utils/copilot-chat-types'
import {AnnotationsList} from './AnnotationsList'

export interface VulnerabilityAnnotationsProps {
  vulnerabilities: CodeVulnerability[]
}

export function VulnerabilityAnnotations({vulnerabilities}: VulnerabilityAnnotationsProps) {
  return (
    <AnnotationsList
      icon={
        <span style={{color: 'var(--fgColor-attention)'}}>
          <AlertIcon />
        </span>
      }
      summary={`${vulnerabilities.length} ${
        vulnerabilities.length === 1 ? 'vulnerability' : 'vulnerabilities'
      } detected`}
    >
      {vulnerabilities.map((vulnerability, i) => (
        // eslint-disable-next-line @eslint-react/no-array-index-key
        <ActionList.Item key={i}>
          {vulnerability.uiType}
          <ActionList.Description variant="block">{vulnerability.uiDescription}</ActionList.Description>
        </ActionList.Item>
      ))}
    </AnnotationsList>
  )
}

try{ VulnerabilityAnnotations.displayName ||= 'VulnerabilityAnnotations' } catch {}